import {AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {HostingDomainData} from "../domains/hostingDomainData";
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {Observable} from 'rxjs';
import {Website} from "../../website";
import {ActivatedRoute} from '@angular/router';
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {HostingService} from "../hosting.service";
import {combineLatest, Subscription} from 'rxjs';
import {IDropdownListItem} from "../../../../shared/components/dropdown-list/dropdown-list-item";
import {FormControl, FormGroup} from '@angular/forms';
import {IFcDropdownSelectOption} from "../../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {DbServerErrors} from "../../../../shared/interceptors/db-server-errors";
import {SortByPipe} from "../../../../shared/pipes/sort-by.pipe";
import {Utils} from "../../../../shared/utils/utils";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {DbDatePipe} from "../../../../shared/pipes/db-date.pipe";
import {UploadCsvDialogComponent} from "./upload-csv-dialog/upload-csv-dialog.component";
import {RemoveRedirectDialogComponent} from "./remove-redirect-dialog/remove-redirect-dialog.component";
import {User} from "../../../../user/user";
import {AddRedirectDialogComponent} from "./add-redirect-dialog/add-redirect-dialog.component";
import {SearchByPropertyPipe} from "../../../../shared/pipes/search-by-property.pipe";
import {Config} from "../../../../config/config";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {DbModalService} from "../../../../modules/modal/modal";
import {UserSubscription} from "../../../../user/user-subscription";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {OneMonthFreeComponent} from "../../../../shared/components/dialogs/one-month-free/one-month-free.component";

@Component({
    selector: 'db-hosting-redirects',
    templateUrl: './hosting-redirects.component.html',
    styleUrls: ['./hosting-redirects.component.scss'],
    standalone: false
})
export class HostingRedirectsComponent implements OnInit, OnDestroy, AfterViewInit {

  public redirects: any;
  public filteredRedirects: any;
  public allDomains: HostingDomainData[];
  public website: Website;
  public primaryChanged: boolean = false;
  public addRedirectForm: FormGroup;
  public subscriptions: Subscription[];
  public removeRedirect: IDropdownListItem[];
  public domainsOptions: IFcDropdownSelectOption[];
  public hasCheckedRedirect: boolean;
  public checkedRedirectsCount: number;
  public status: FormControl;
  public domains: FormControl;
  public formSubmitted: boolean;
  public loading: boolean;
  public hasServerFieldErrors: boolean;
  public downloadLoading: boolean;
  public serverErrors: DbServerErrors;
  public redirectsLoading$: Observable<boolean>;
  public sortBy: FormControl;
  public sortDirection: FormControl;
  public sortDirectionClassName: string = "db-sort-direction-asc";
  private sortByDefaultValue: string = "domains";
  private sortDirectionDefault: string = "desc";
  public selectAll: FormControl;
  public hasHostingBanner: any;
  public user: User;
  public userSubscription: UserSubscription;
  public searchTerm: FormControl;
  demoUser = false;

  public isScrolled: boolean;
  public position: number = 50;
  public scrolled: number = 50;


  public currentPage: number = 1;
  public itemsPerPage: number = 20;
  public itemsCount: number = 200;
  public pagesCount: number = 10;

  public firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360027578532-How-to-Set-Up-Redirects-on-Your-WordPress-Site";
  public secondInfoLink: string = "https://help.10web.io/hc/en-us/articles/360010699320-How-to-Fix-404-Not-Found-Error";
  public thirdInfoLink: string = "https://help.10web.io/hc/en-us/articles/360010814659-How-to-Fix-ERR-TOO-MANY-REDIRECTS-Error";

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _hostingService: HostingService,
    private _sortPipe: SortByPipe,
    private _dbDatePipe: DbDatePipe,
    private _searchPipe: SearchByPropertyPipe,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,

  ) {}

  ngOnInit(): void {
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.getWebsite(this.website?.id);
    this.redirectsLoading$ = this._store.select(fromStore.getRedirectsLoading(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id));
    this.sortBy = new FormControl(this.sortByDefaultValue);
    this.sortDirection = new FormControl(this.sortDirectionDefault);
    const domainsFormatted = [];
    this.domains = new FormControl("");
    this.selectAll = new FormControl('');
    this.searchTerm = new FormControl('');

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription)
        )),
        first()
      )
      .subscribe(([user, userSubscription]) => {
        this.demoUser = Utils.isDemoUser(userSubscription, user);
        this.user = user;
        this.userSubscription = userSubscription;
        this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
      });

    this._store.select(fromStore.getDomains(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((domains: HostingDomainData[]) => {
      if (domains.length && !this.allDomains) {
        this.allDomains = domains;

        domains.map( domain => {
          domainsFormatted.push({
            "label": domain.name,
            "value": domain.id
          });
        });
        this.domainsOptions = domainsFormatted;
        if (this.domainsOptions.length) {
          this.domains.setValue(this.domainsOptions[0].value);
        }
      }
    });

    this.removeRedirect = [
      {
        icon: 'plugins',
        label: 'Remove Redirect',
        action: (item) => {
          this.confirmRemove(item, false);
        }
      }
    ];
    // this._store.dispatch(new fromStore.LoadRedirects(this.website.id));
    this.addEventHandlers();

}

  private setPaginationData(): void {
    this.itemsCount = this.filteredRedirects.length;
    this.pagesCount = Math.ceil(this.itemsCount / this.itemsPerPage);
    this.currentPage = 1;
  }


  public onChangePage(page: number): void {
    this.currentPage = page;
  }

  public toggleAllItemsSelected(selected: boolean): void {
    this.redirects.forEach((redirect: any): void => {
      redirect.selected = selected;
    });
    this.updateSelectAllState();
  }

  private updateSelectAllState(): void {
    this.hasCheckedRedirect = false;
    this.checkedRedirectsCount = 0;
    this.redirects.map((redirect: any): any => {
      if (redirect.selected) {
        this.hasCheckedRedirect = true;
        this.checkedRedirectsCount++;
      }
    });
    this.selectAll.setValue(this.redirects.length && !this.redirects.find((redirect: any): boolean => !redirect.selected));
  }

  public onItemToggled(): void {
    this.updateSelectAllState();
  }

  public onRedirectToggled(event: Event, redirect: any): void {
    const target = event.target as HTMLInputElement;
    redirect.selected = target.checked;
    this.onItemToggled();
  }

  public get selectedRedirects(): any[] {
    if (!this.redirects) {
      return [];
    }

    return this.redirects.filter((redirect: any): boolean => {
      return redirect.selected;
    });
  }

  public getWebsite(websiteId): void {
    this._store.select(fromStore.getWebsite(websiteId)).subscribe((website: Website) => {
      this.website = website;
      this.primaryChanged = !Utils.checkStringInArray(this.website.site_url, Config.hostnameList);
    });
  }
  public sortTable(sortBy: string, sortDirectionDefault: string = ""): void {
    let sortDirection: string = this.sortDirection.value;
    if (sortDirectionDefault === "") {
      if (sortBy === this.sortBy.value) {
        sortDirection = (sortDirection === 'asc') ? 'desc' : 'asc';
      }
      else {
        sortDirection = this.sortDirectionDefault;
      }
    } else {
      sortDirection = sortDirectionDefault;
    }

    this.sortDirection.setValue(sortDirection);
    this.sortBy.setValue(sortBy);

    this.sortDirectionClassName = 'db-sort-direction-' + sortDirection;
  }

  public getSortDirectionClass(sortBy: string) {
    if (sortBy === this.sortBy.value) {
      return 'db-table-sorting-indicator_active db-sort-direction-' + this.sortDirection.value;
    }
    else {
      return 'db-sort-direction-asc';
    }
  }

  private updateData() {
    let redirects;
    if (this.sortBy.value === 'statusCode') {
      redirects = this._sortPipe.transform(this.redirects, this.sortBy.value, this.sortDirection.value);
    }
    else {
      if (this.sortDirection.value === 'asc') {
        redirects = this.redirects.sort( (a, b) => {
          if (a[this.sortBy.value] < b[this.sortBy.value]) {
            return -1;
          }
          else if (a[this.sortBy.value] > b[this.sortBy.value]) {
            return 1;
          }
          else {
            return 0;
          }
        });
      }
      else if (this.sortDirection.value === 'desc') {
        redirects = this.redirects.sort( (a, b) => {
          if (a[this.sortBy.value] > b[this.sortBy.value]) {
            return -1;
          }
          else if (a[this.sortBy.value] < b[this.sortBy.value]) {
            return 1;
          }
          else {
            return 0;
          }
        });
      }
    }
    this.redirects = redirects;
  }


  ngAfterViewInit(): void {
    if (document.getElementById("db-redirects-block-body") && window.innerWidth > 991) {
      // this._malihuScrollbarService.initScrollbar(document.getElementById("db-redirects-block-body"), Object.assign(Config.malihuScrollbarDefaultOptions, {
      //   callbacks: {
      //     onScroll: () => {
      //       const offsetTop = <HTMLElement> document.querySelector('.db-redirects-block-body .mCSB_container');
      //       if (offsetTop) {
      //         this.scrolled = 1 - offsetTop.offsetTop;
      //         /*if (this.scrolled >= this.position) {*/
      //         if (this.scrolled > 10) {
      //           (<HTMLElement>document.getElementById("db-hosting-redirects")).classList.add("isScrolled");
      //         } else {
      //           (<HTMLElement>document.getElementById("db-hosting-redirects")).classList.remove("isScrolled");
      //         }
      //         setTimeout(() => {
      //           this.position = this.scrolled;
      //         }, 1000);
      //       }
      //     }
      //   }
      // }));
    }
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(this.sortBy.valueChanges.subscribe((): void => {
      this.updateData();
    }));
    this.subscriptions.push(this._store.select(fromStore.getRedirects(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id)).subscribe((redirects: any) => {

      if (redirects) {
        this.redirects = redirects;
        this.filteredRedirects = redirects;
        this.setPaginationData();
        this.updateData();
      }
    }));

    this.subscriptions.push(this.searchTerm.valueChanges.subscribe((): void => {
      this.filteredRedirects = this._searchPipe.transform(this.redirects, {'domains': this.searchTerm.value, 'redirectFrom': this.searchTerm.value, 'redirectTo': this.searchTerm.value});
    }));
  }

  public confirmRemove(redirect, multipleRules) {
    this._dialogService
      .addDialog(RemoveRedirectDialogComponent, {
        websiteId: !this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id,
        redirect: redirect,
        multipleRules: multipleRules
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadRedirects(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id));
          this.selectAll = new FormControl('');
          this.checkedRedirectsCount = 0;
          this.hasCheckedRedirect = false;
        }
      });
  }

  public addRedirectDialog(redirect: any|null = null) {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId && this.demoUser) {
      return this.showCheckoutDialog('Add Redirect');
    }
    this._dialogService
      .addDialog(AddRedirectDialogComponent, {
        websiteId: !this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id,
        redirect: redirect
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadRedirects(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id));
          this.selectAll = new FormControl('');
        }
      });
  }


  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }


  public uploadCsv() {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId && this.demoUser) {
      return this.showCheckoutDialog('Bulk Import');
    }
    this._dialogService
      .addDialog(UploadCsvDialogComponent, {
        websiteId: !this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadRedirects(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id));
        }
      });
  }

  public downloadCsv() {
    this.downloadLoading = true;
    this._hostingService.startDownloadingCsv(!this.website?.parentId && this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe((response): void => {
        if (response && response.success) {
          Utils.downloadBlob(response.data, `redirects_${this._dbDatePipe.transform(new Date(), 'yyyy-MM-dd_HH-mm-ss')}`);
        }
        else {
          NotifierComponent.notify(new Notification(response.message || "something went wrong", NotificationType.DANGER));
        }
        this.downloadLoading = false;
      });
  }

  private showCheckoutDialog(label: string): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: "Locked button click",
      eventLabel: label
    };
    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'editor';
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  @HostListener('document:mousemove', ['$event']) onMouseMove($event: any) {
    const x = $event.clientX,
      y = $event.clientY;
    if ($event.target.parentElement && $event.target.parentElement.classList.contains("redirect-item__with-tooltip")) {
      const recordItemNameTooltipSpan = $event.target.parentElement.children[1];
      recordItemNameTooltipSpan.style.top = (y - 70) + 'px';
      recordItemNameTooltipSpan.style.left = (x + 20) + 'px';
    }

  }

}
